/**
 * Supplies the workspace the caller is acting in. The Engine .NET APIs resolve the current user
 * from `X-Engine-Workspace-Id`, and throw when it is absent, so any app whose endpoints go
 * through `ICurrentUserProvider` has to register this. Apps hold the value in React context,
 * hence a getter rather than a value.
 */
type WorkspaceIdGetter = () => string | undefined;

let workspaceIdGetter: WorkspaceIdGetter | undefined;

export function registerWorkspaceIdGetter(getter: WorkspaceIdGetter): void {
  workspaceIdGetter = getter;
}

export function getWorkspaceId(): string | undefined {
  return workspaceIdGetter?.();
}
